import { Pagination } from '@brighterion/br-ui';
import React from 'react';
import { NumberService } from 'Services';
import styles from './index.css';

export default function PaginationRow({
    pageSize,
    setPageSize,
    pageIndex,
    gotoPage,
    pageCount,
    nextPage,
    previousPage
}: PaginationComponentProps) {
    return (
        <div data-testid='pagination-container' className={styles.paginationRow}>
            <span className={styles.inlinePaginationOuterWrapper}>
                <Pagination.InlinePagination
                    ellipses
                    ellipsesComponent='···'
                    arrowConfig='single'
                    eNumPagesDisplay={6}
                    ellipsesIndex={2}
                    totalPages={pageCount}
                    currentPage={pageIndex + 1}
                    nextPageClickCallback={nextPage}
                    prevPageClickCallback={previousPage}
                    directPageClickCallback={(e) => {
                        gotoPage(Number(e.currentTarget.innerText) - 1);
                    }}
                    numberFormatFn={NumberService.getLocaleNumber}
                />
            </span>
            <Pagination.ResultsPerPageDropdown
                incrementor={10}
                start={10}
                end={40}
                currentPageSize={pageSize}
                pageCount={0}
                totalResultsLabel={false}
                onChange={setPageSize}
                numberFormatFn={NumberService.getLocaleNumber}
            />
        </div>
    );
}
